<template>
  <div>
    <Modal v-model="reNameModal" title="重命名表" @on-cancel="newName = ''; oldTableName = ''">
      <Alert show-icon>正在重命名表「{{ oldTableName }}」</Alert>
      新表名：<Input v-model="newName" placeholder="请输入新的表名" />
      <div slot="footer">
        <Button type="primary" @click="reNameOk" :loading="reNaming">提交</Button>
        <Button @click="reNameModal = false" style="margin-left: 8px">取消</Button>
      </div>
    </Modal>

    <!-- copy table modal-->
    <Modal v-model="copyTableModal" title="复制表" @on-cancel="newName = ''; oldTableName = '';copyType=1">
      <Alert show-icon>正在从表「{{oldTableName}}」复制到「{{ newName }}」</Alert>
      表名：<Input v-model="newName" placeholder="请输入复制的表名" />
      <RadioGroup v-model="copyType" style="padding-top: 20px">
        <Radio :label="0"><span>表结构</span></Radio>
        <Radio :label="1"><span>表结构+数据</span></Radio>
      </RadioGroup>
      <div slot="footer">
        <Button type="primary" @click="copyTableOk" :loading="copying">提交</Button>
        <Button @click="copyTableModal = false" style="margin-left: 8px">取消</Button>
      </div>
    </Modal>

    <Row>
      <!--<Row>-->
        <!--<ButtonGroup>-->
          <!--<Button type="primary" :disabled="!selectTable" icon="ios-folder-open-outline" @click="openTable(selectTable)">打开表</Button>-->
          <!--<Button type="primary" :disabled="!selectTable" icon="ios-create-outline" @click="modifyTable(selectTable)">设计表</Button>-->
          <!--<Button type="primary" :disabled="!selectTable" icon="ios-card-outline" @click="openReNameModal(selectTable)" :loading="reNaming">重命名表</Button>-->
          <!--<Button type="primary" icon="ios-add-circle-outline" @click="$emit('callBack', 'createTable', callbackdata)">新建表</Button>-->
          <!--<Button type="error" :disabled="!selectTable" icon="ios-trash-outline" @click="deleteTable(selectTable)" :loading="deleting">删除表</Button>-->
        <!--</ButtonGroup>-->
        <!--<Button type="primary" style="float: right" icon="ios-refresh" @click="getTablesData(callbackdata)" :loading="getDataIng">刷新</Button>-->
        <!--<Divider dashed ></Divider>-->
      <!--</Row>-->
      <div v-for="(item, index) in data" :key="index" style="padding-left: 10px; display:block; width: 350px; float: left; line-height: 25px;">
        <Dropdown trigger="contextMenu" @on-click="v=>{ clickTools(v, item)}" transfer :class="{'table-list-item': true, 'table-list-item-active': item === selectTable}">
          <span v-on:dblclick="openTable(item)" v-on:click="select(item)">
            <span><font-awesome-icon icon="table" style="color: #2d8cf0" /></span>
            <span style="padding-left: 5px">{{ item }}</span>
          </span>
          <DropdownMenu @on-click="v=>{ clickTools(v, item)}" slot="list" transfer>
            <DropdownItem name="create">新建表</DropdownItem>
            <DropdownItem name="open">打开表</DropdownItem>
            <DropdownItem name="modifyTable">编辑表结构</DropdownItem>
            <DropdownItem name="truncateTable"  :style="{ color: deleting ? '' : 'red' }">清空表</DropdownItem>
            <DropdownItem name="reName" :disabled="reNaming">重命名表</DropdownItem>
            <DropdownItem name="copyTable" :disabled="copying">复制表</DropdownItem>
            <!--<Dropdown placement="right-start" transfer>-->
              <!--<DropdownItem>-->
                <!--转储SQL文件-->
                <!--<Icon type="ios-arrow-forward"></Icon>-->
              <!--</DropdownItem>-->
              <!--<DropdownMenu slot="list">-->
                <!--<DropdownItem name="analyzeTable">表结构</DropdownItem>-->
                <!--<DropdownItem name="optimizerTable">表结构+数据</DropdownItem>-->
              <!--</DropdownMenu>-->
            <!--</Dropdown>-->
            <DropdownItem name="delete" :style="{ color: deleting ? '' : 'red' }" :disabled="deleting">删除表</DropdownItem>
            <Dropdown placement="right-start" transfer>
              <DropdownItem>
                表维护
                <Icon type="ios-arrow-forward"></Icon>
              </DropdownItem>
              <DropdownMenu slot="list">
                <DropdownItem name="analyzeTable">分析表</DropdownItem>
                <DropdownItem name="optimizeTable">优化表</DropdownItem>
                <DropdownItem name="checkTable">检查表</DropdownItem>
                <DropdownItem name="repairTable">修复表</DropdownItem>
              </DropdownMenu>
            </Dropdown>
            <DropdownItem name="refreshTable">刷新</DropdownItem>
            <DropdownItem name="tableInfo">对象信息</DropdownItem>
          </DropdownMenu>
        </Dropdown>
      </div>
    </Row>
    <Row style="margin-top: 30px">
      <SQLResults ref="SQLResults" :callbackdata="callbackdata" :log="false"></SQLResults>
    </Row>
  </div>
</template>

<script>
import { showTableList, executeSQL, getTableInfo } from '@/api/mysql'
import SQLResults from './sqlResults'
export default {
  name: 'tableList',
  components: {
    SQLResults
  },
  data () {
    return {
      data: [],
      getDataIng: false,
      selectTable: '',
      deleting: false,
      // 重命名表
      reNameModal: false,
      reNaming: false,
      // 复制表
      copyTableModal: false,
      copying: false,
      copyType: 1,
      oldTableName: '',
      newName: ''
    }
  },
  props: {
    callbackdata: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  mounted () {
    this.getTablesData(this.callbackdata)
  },
  methods: {
    // 获取表列表数据
    getTablesData (dbParam) {
      let params = {
        db: dbParam.db,
        id: dbParam.instance_id
      }
      this.getDataIng = true
      showTableList(params).then(res => {
        this.getDataIng = false
        this.selectTable = ''
        this.data = res.data.results
      }).catch(res => {
        this.getDataIng = false
      })
    },
    // 打开表
    openTable (tableName) {
      let data = {
        table: tableName,
        db: this.callbackdata.db
      }
      this.$emit('callBack', 'openTable', data)
    },
    // 设计表
    modifyTable (tableName) {
      let data = {
        table: tableName,
        db: this.callbackdata.db
      }
      this.$emit('callBack', 'modifyTable', data)
    },

    // 右键触发下拉工具
    clickTools (type, tableName) {
      switch (type) {
        case 'create':
          this.$emit('callBack', 'createTable', this.callbackdata)
          break
        case 'open':
          this.openTable(tableName)
          break
        case 'delete':
          this.deleteTable(tableName)
          break
        case 'reName':
          this.openReNameModal(tableName)
          break
        case 'modifyTable':
          this.modifyTable(tableName)
          break
        case 'refreshTable':
          this.refreshTable()
          break
        case 'truncateTable':
          this.truncateTable(tableName)
          break
        case 'copyTable':
          this.openCopyTableModal(tableName)
          break
        case 'analyzeTable':
          this.analyzeTable(tableName)
          break
        case 'optimizeTable':
          this.optimizeTable(tableName)
          break
        case 'checkTable':
          this.checkTable(tableName)
          break
        case 'repairTable':
          this.repairTable(tableName)
          break
        case 'tableInfo':
          this.tableInfo(tableName)
          break
      }
    },
    // 选中/取消选中 表
    select (tableName) {
      if (this.selectTable === tableName) {
        this.selectTable = ''
      } else {
        this.selectTable = tableName
      }
    },
    // 删除表
    deleteTable (tableName) {
      if (this.deleting) {
        return false
      }
      this.$Modal.confirm({
        title: '确认删除表「' + tableName + '」吗？',
        onOk: () => {
          this.deleting = true
          let sql = 'DROP TABLE ' + tableName + ';'
          this.execSQLAction(sql, 'delete')
        }
      })
    },
    // 打开重命名模态框
    openReNameModal (tableName) {
      this.oldTableName = tableName
      this.reNameModal = true
    },
    // 重命名表
    reNameOk () {
      if (!this.newName) {
        this.$Notice.error({
          title: '表名不能为空'
        })
        return false
      }
      let sql = 'ALTER TABLE ' + this.oldTableName + ' RENAME TO ' + this.newName + ';'
      this.reNaming = true
      this.execSQLAction(sql, 'reName')
    },
    // refresh table list
    refreshTable () {
      this.getTablesData(this.callbackdata)
    },
    // truncate table
    truncateTable (tableName) {
      this.$Modal.confirm({
        title: '确认清空表「' + tableName + '」吗？',
        onOk: () => {
          this.deleting = true
          let sql = 'TRUNCATE TABLE ' + this.oldTableName + ';'
          this.execSQLAction(sql, '')
        }
      })
    },
    // open copy table modal
    openCopyTableModal (tableName) {
      this.oldTableName = tableName
      this.copyTableModal = true
    },
    // copy table
    copyTableOk () {
      if (!this.newName) {
        this.$Notice.error({
          title: '表名不能为空'
        })
        return false
      }
      let sql = 'CREATE TABLE `' + this.newName + '` LIKE `' + this.oldTableName + '`;'

      if (this.copyType) {
        sql += 'INSERT INTO `' + this.newName + '` SELECT * FROM `' + this.oldTableName + '`'
      }

      this.copying = true
      this.execSQLAction(sql, 'copyTable')
    },
    // 分析表
    analyzeTable (tableName) {
      let sql = 'ANALYZE TABLE ' + tableName + ';'
      this.execSQLAction(sql, '')
    },
    // 优化表
    optimizeTable (tableName) {
      let sql = 'OPTIMIZE TABLE ' + tableName + ';'
      this.execSQLAction(sql, '')
    },
    // 检查表
    checkTable (tableName) {
      let sql = 'CHECK TABLE ' + tableName + ';'
      this.execSQLAction(sql, '')
    },
    // 修复表
    repairTable (tableName) {
      let sql = 'REPAIR TABLE ' + tableName + ';'
      this.execSQLAction(sql, '')
    },
    // 对象信息
    tableInfo (tableName) {
      let sql = "select table_schema, table_name, engine, table_rows, concat(round(data_length/1024/1024,2), 'M(', data_length, ')') as 'data_length' ,\n" +
        "concat(round(index_length/1024/1024,2), 'M(', index_length, ')') as 'index_length'  , data_free,\n" +
        'create_time, update_time, check_time, auto_increment,row_format,  table_collation, create_options, table_comment  \n' +
        "from information_schema.tables where table_name='" + tableName + "' and table_schema='" + this.callbackdata.db + "';"
      sql += 'show create table `' + this.callbackdata.db + '`.`' + tableName + '`;'
      this.getTableInfo(sql)
    },
    // 执行SQL动作
    execSQLAction (sql, type) {
      let data = {
        id: this.callbackdata.instance_id,
        db: this.callbackdata.db,
        sql: sql,
        limit: 100
      }
      executeSQL(data).then(res => {
        let results = []
        res.data.results.forEach(function (item, index) {
          results.push({ 'id': index + 1, 'res': item['data'], 'columns': [], 'msg': item['msg'] })
          let cols = Object.keys(item['data'][0])
          if (cols) {
            cols.forEach(function (row) {
              results[index].columns.push({ 'title': row, 'key': row, 'minWidth': 130 })
            })
          }
        })
        this.$refs.SQLResults.showResult(results)
        switch (type) {
          case 'delete': {
            this.deleting = false
            this.getTablesData(this.callbackdata)
            break
          }
          case 'reName': {
            this.reNaming = false
            this.reNameModal = false
            this.newName = ''
            this.getTablesData(this.callbackdata)
            break
          }
          case 'copyTable': {
            this.copying = false
            this.copyTableModal = false
            this.newName = ''
            this.getTablesData(this.callbackdata)
            break
          }
        }
      }).catch(res => {
        switch (type) {
          case 'delete': {
            this.deleting = false
            this.getTablesData(this.callbackdata)
            break
          }
          case 'reName': {
            this.reNaming = false
            this.getTablesData(this.callbackdata)
          }
        }
        if (res.request) {
          this.$Notice.error({
            title: '操作失败！请求状态码:' + res.request.status,
            desc: res.request.response
          })
        } else {
          this.$Notice.error({
            title: '操作失败！服务器无响应'
          })
        }
      })
    },

    // 执行SQL动作
    getTableInfo (sql) {
      let data = {
        id: this.callbackdata.instance_id,
        db: this.callbackdata.db,
        sql: sql,
        limit: 100
      }
      getTableInfo(data).then(res => {
        let results = []
        res.data.results.forEach(function (item, index) {
          results.push({ 'id': index + 1, 'res': item['data'], 'columns': [], 'msg': item['msg'] })
          let cols = Object.keys(item['data'][0])
          if (cols) {
            cols.forEach(function (row) {
              results[index].columns.push({ 'title': row, 'key': row, 'minWidth': 130 })
            })
          }
        })
        this.$refs.SQLResults.showResult(results)
      }).catch(res => {
        if (res.request) {
          this.$Notice.error({
            title: '操作失败！请求状态码:' + res.request.status,
            desc: res.request.response
          })
        } else {
          this.$Notice.error({
            title: '操作失败！服务器无响应'
          })
        }
      })
    }
  }
}
</script>

<style scoped>
  .table-list-item:hover {
    color: #2d8cf0;
    cursor:pointer;
  }
  .table-list-item:visited {
    color: #2d8cf0;
  }
  .table-list-item-active {
    background-color: rgb(243, 243, 243);
    color: #2d8cf0;
  }
</style>
